export default __webpack_public_path__ + "static/post_venta-d422cbd21fefa6d6dc8cb1633db5a3fa.png";